import { SITE_URL } from '../api';

const publicAssetVariants = (() => {
  if (typeof document === 'undefined') return {};
  try {
    return JSON.parse(document.getElementById('public-asset-variants')?.textContent || '{}');
  } catch {
    return {};
  }
})();

function getOptimizedAssetUrl(value) {
  try {
    const url = new URL(value, SITE_URL);
    url.search = '';
    url.hash = '';
    return publicAssetVariants[url.href] || null;
  } catch {
    return null;
  }
}

export function resolvePublicAssetUrl(value) {
  if (typeof value !== 'string' || value === '') return value;
  if (/^(?:https?:|data:|blob:)/i.test(value)) return getOptimizedAssetUrl(value) || value;

  const normalizedPath = value.startsWith('/')
    ? value
    : /^(?:images|figma-icons|uploads)\//i.test(value)
      ? `/${value}`
      : value;

  if (!normalizedPath.startsWith('/')) return normalizedPath;
  return `${SITE_URL}${normalizedPath}`;
}
